module.exports = __webpack_public_path__ + "img/4.86b38aee.jpg";